import { render, staticRenderFns } from "./CompareList.vue?vue&type=template&id=e75cf1a2"
import script from "./CompareList.vue?vue&type=script&lang=js"
export * from "./CompareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports